module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fullscreen-overlay-layout', {
    attrs: {
      "title": _vm.getCurrentRT.title
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    class: {
      'hidden-record': _vm.submission.is_hidden
    },
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('submission-card-header', {
    attrs: {
      "showHeaderOptions": false,
      "showVersions": false,
      "submission": _vm.submission
    }
  }), _vm._v(" "), _c('submission-response-text', {
    attrs: {
      "submission": _vm.submission,
      "disableMinimizeText": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "start-xs"
  }, [_c('span', {
    staticClass: "i",
    staticStyle: {
      "font-size": "12px",
      "color": "#273248"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.getPromptWordsLength) + " Words\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto mt3 mb4 tr"
  }, [_c('comments-tab', {
    staticClass: "br3",
    attrs: {
      "submission": _vm.submission,
      "showComments": true
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-08526667!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/individualSubmissionOverlay.vue
// module id = 1185
// module chunks = 61